import { settingApi } from './settingApi';

const NOTIFICATION_API = {
  list: 'api/notifications/list',
  markAsRead: 'api/notifications/markAsRead',
};

export const notificationApi = settingApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotificationList: builder.mutation({
      query: (messageFilter: any) => ({
        url: NOTIFICATION_API.list,
        method: 'POST',
        body: messageFilter,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: { data?: { notifications?: any[]; totalPages?: number } }) => ({
        list: response?.data?.notifications ?? [],
        totalPages: response?.data?.totalPages ?? 0,
      }),
    }),
    notificationMarkAsRead: builder.mutation({
      query: (messageFilter: any) => ({
        url: NOTIFICATION_API.markAsRead,
        method: 'POST',
        body: messageFilter,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
  }),
});

export const { useGetNotificationListMutation, useNotificationMarkAsReadMutation } =
  notificationApi;
